<template>
  <ContentfulRenderer
    class="the-footer-responsible-play caption-regular"
    :data="footer?.items?.[0]?.responsibleGamingSection"
  />
</template>

<script lang="ts" setup>
const { data: footer } = useContent().getFooter()
</script>

<style lang="scss" scoped>
.the-footer-responsible-play {
  :deep(a) {
    display: inline-flex;
  }

  :deep(p) {
    + p {
      margin-top: token('size/space/gap/100');
      color: token('color/text/secondary/secondary');
    }
  }
}
</style>
